// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const Description = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaForm.description"
        description="Description."
        defaultMessage="Add a link that users can interact with while using your lens."
    />
);
Description.displayName = "Description";

export const FormTooltipType = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaForm.formTooltipType"
        description="Form tooltip type."
        defaultMessage="Select the Call-to-Action type for users to engage with."
    />
);
FormTooltipType.displayName = "FormTooltipType";

export const FormTooltipUrl = (): ReactElement => (
    <>
        {" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipUrl"
            description="Form tooltip url."
            defaultMessage="Where Snapchatters will be taken when they click on the Call-to-Action. "
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipUrl"
            description="Form tooltip url."
            defaultMessage='Please include the network location (e.g., "http://" or "https://") in the URL.'
        />
    </>
);
FormTooltipUrl.displayName = "FormTooltipUrl";

export const FormTooltipUri = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaForm.formTooltipUri"
        description="Form tooltip uri."
        defaultMessage="Where Snapchatters will be taken when they click on the Call-to-Action."
    />
);
FormTooltipUri.displayName = "FormTooltipUri";

export const FormTooltipAppName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaForm.formTooltipAppName"
        description="Form tooltip app name."
        defaultMessage="Name of your App"
    />
);
FormTooltipAppName.displayName = "FormTooltipAppName";

export const FormTooltipIosAppId = (): ReactElement => (
    <>
        {" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipIosAppId"
            description="Form tooltip ios app id."
            defaultMessage="This is a required field. The Apple Store ID should be numeric value only "
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipIosAppId"
            description="Form tooltip ios app id."
            defaultMessage="(e.g., Snapchat's Apple Store ID is “447188370”). If user does not have app installed, "
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipIosAppId"
            description="Form tooltip ios app id."
            defaultMessage="the user will fallback to the Apple Store to download the app."
        />
    </>
);
FormTooltipIosAppId.displayName = "FormTooltipIosAppId";

export const FormTooltipAndroidAppUrl = (): ReactElement => (
    <>
        {" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipAndroidAppUrl"
            description="Form tooltip android app url."
            defaultMessage="This is a required field. The Google Play Store ID can be found after “id=” in store "
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipAndroidAppUrl"
            description="Form tooltip android app url."
            defaultMessage="URL (e.g., Snapchat's Google Play Store ID is “com.snapchat.android”. If user does not have app "
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lensCta.components.lensCtaForm.formTooltipAndroidAppUrl"
            description="Form tooltip android app url."
            defaultMessage="installed, the user will fallback to the Google Play Store to download the app."
        />
    </>
);
FormTooltipAndroidAppUrl.displayName = "FormTooltipAndroidAppUrl";

export const FormTooltipText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaForm.formTooltipText"
        description="Form tooltip text."
        defaultMessage="Select the text for your Call-to-Action, which will appear over the Camera button."
    />
);
FormTooltipText.displayName = "FormTooltipText";

export const CtaTypeLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaForm.ctaTypeLabel"
        description="Cta type label."
        defaultMessage="Type"
    />
);
CtaTypeLabel.displayName = "CtaTypeLabel";

export const messages = defineMessages({
    formLabelType: {
        id: "apps.lensCta.components.lensCtaForm.formLabelType",
        description: "Form label type.",
        defaultMessage: "Call-to-Action Type",
    },
    formLabelUrl: {
        id: "apps.lensCta.components.lensCtaForm.formLabelUrl",
        description: "Form label url.",
        defaultMessage: "Website URL",
    },
    formPlaceholderUrl: {
        id: "apps.lensCta.components.lensCtaForm.formPlaceholderUrl",
        description: "Form placeholder url.",
        defaultMessage: "https://www.website.com",
    },
    formLabelUri: {
        id: "apps.lensCta.components.lensCtaForm.formLabelUri",
        description: "Form label uri.",
        defaultMessage: "Deep Link URI",
    },
    formPlaceholderUri: {
        id: "apps.lensCta.components.lensCtaForm.formPlaceholderUri",
        description: "Form placeholder uri.",
        defaultMessage: "yourapp://yourlink",
    },
    formLabelAppName: {
        id: "apps.lensCta.components.lensCtaForm.formLabelAppName",
        description: "Form label app name.",
        defaultMessage: "App Name",
    },
    formPlaceholderAppName: {
        id: "apps.lensCta.components.lensCtaForm.formPlaceholderAppName",
        description: "Form placeholder app name.",
        defaultMessage: "Your App Name, e.g. Snapchat",
    },
    formLabelIosAppId: {
        id: "apps.lensCta.components.lensCtaForm.formLabelIosAppId",
        description: "Form label ios app id.",
        defaultMessage: "iOS App ID",
    },
    formPlaceholderIosAppId: {
        id: "apps.lensCta.components.lensCtaForm.formPlaceholderIosAppId",
        description: "Form placeholder ios app id.",
        defaultMessage: "12345678",
    },
    formLabelAndroidAppUrl: {
        id: "apps.lensCta.components.lensCtaForm.formLabelAndroidAppUrl",
        description: "Form label android app url.",
        defaultMessage: "Android App URL",
    },
    formPlaceholderAndroidAppUrl: {
        id: "apps.lensCta.components.lensCtaForm.formPlaceholderAndroidAppUrl",
        description: "Form placeholder android app url.",
        defaultMessage: "com.myapp.android",
    },
    formLabelText: {
        id: "apps.lensCta.components.lensCtaForm.formLabelText",
        description: "Form label text.",
        defaultMessage: "Call-to-Action Text",
    },
});
